import React from 'react';
import { useIntl } from 'react-intl';
import InfoWrapper from '../info-wrapper';
import { StatusProps } from '../..';
import { Alert } from 'ui';
import parse from 'html-react-parser';
import { DateVoteCount } from '../date-vote-status';
import { Tag } from 'antd';

const NotSupportedState = ({ votingPeriodFrom, votingPeriodTo, voteCount, submittedProject }: StatusProps) => {
  const intl = useIntl();

  return (
    <InfoWrapper>
      <div className="text_side">
        <DateVoteCount votingPeriodFrom={votingPeriodFrom} votingPeriodTo={votingPeriodTo} voteCount={voteCount} />
        <Tag className={`status ${submittedProject.state}`}>
          {intl.formatMessage({ id: `participation_budget.${submittedProject.state}` })}
        </Tag>
      </div>
      {submittedProject?.versions[0]?.state_explanation && (
        <Alert type="warning" message={parse(submittedProject?.versions[0]?.state_explanation)} className="mt-4" />
      )}
    </InfoWrapper>
  );
};

export default NotSupportedState;
